import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { marketSelector } from '../../../app/selectors/contactUsSelector';
import { NotesField } from '../../presentationalComponents/RequestDetails/NotesField';
import {
  updateNote,
} from '../../reduxUpdater/actions/requestDetailsActions';
import { addNoteConfigSelector } from '../../reduxUpdater/selectors/requestDetailsSelectors';
import { getRequestDetailsStyles } from '../../styles/requestDetailsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    addNoteConfig: addNoteConfigSelector(state),
    market: marketSelector(state),
  };
};

const mapDispatchToProps = {
  updateNote,
};

export const NotesFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(NotesField, getRequestDetailsStyles));
